import { memo, Suspense, lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/layout/Header/Header'
import Content from './components/Content'
import Footer from './components/Footer'
import ErrorBoundary from './components/ErrorBoundary'
import { CartProvider } from './stores/CartProvider'
import { CartDropdown } from './components/features/Cart/CartDropdown'
import LoadingState from './components/LoadingState'
import { useLoadingState } from './hooks/useLoadingState'

// Lazy load components for better performance
const KIGenerator = lazy(() => import('./components/pages/KIGenerator'))
const Produkte = lazy(() => import('./components/pages/Produkte'))
const AlleProdukte = lazy(() => import('./components/pages/AlleProdukte'))
const Kategorien = lazy(() => import('./components/pages/Kategorien'))
const Anlaesse = lazy(() => import('./components/pages/Anlaesse'))

const App = memo(() => {
  const { isLoading } = useLoadingState()

  if (isLoading) {
    return <LoadingState />
  }

  return (
    <ErrorBoundary>
      <CartProvider>
        <Router>
          <Suspense fallback={null}>
            <Routes>
              <Route
                path="/produkte"
                element={
                  <div className="relative">
                    <div className="fixed top-0 left-0 right-0 z-50">
                      <Header />
                    </div>
                    <Produkte />
                  </div>
                }
              />
              <Route
                path="/alle-produkte"
                element={
                  <div className="relative">
                    <div className="fixed top-0 left-0 right-0 z-50">
                      <Header />
                    </div>
                    <AlleProdukte />
                  </div>
                }
              />
              <Route
                path="/kategorien"
                element={
                  <div className="relative">
                    <div className="fixed top-0 left-0 right-0 z-50">
                      <Header />
                    </div>
                    <Kategorien />
                  </div>
                }
              />
              <Route
                path="/anlaesse"
                element={
                  <div className="relative">
                    <div className="fixed top-0 left-0 right-0 z-50">
                      <Header />
                    </div>
                    <Anlaesse />
                  </div>
                }
              />
              <Route
                path="/*"
                element={
                  <div className="min-h-screen flex flex-col">
                    <Header />
                    <Routes>
                      <Route path="/" element={<Content />} />
                      <Route path="/ki-generator" element={<KIGenerator />} />
                    </Routes>
                    <Footer />
                  </div>
                }
              />
            </Routes>
          </Suspense>
          <CartDropdown />
        </Router>
      </CartProvider>
    </ErrorBoundary>
  )
})
App.displayName = 'App'
export default App
